import { Channel } from 'types/masterData'
import { kebabToCamel } from 'utils/kebabToCamel'

export interface Content {
	[key: string]: unknown
}

interface OutletContent {
	contentOverwriteSelector?: string[] | null
}

function assignContentSelector<T extends Content>(
	selector: string[],
	target: T,
	source: T & OutletContent
) {
	let updatedTarget = { ...target }

	selector.forEach((sel) => {
		const key = kebabToCamel(sel.replace(/\./g, ''))
		if (key && source[key]) {
			updatedTarget = { ...updatedTarget, ...{ [key]: source[key] } }
		}
	})

	return updatedTarget
}

export function filterContentByStore<T extends Content>(
	main: { content: T; outletContent?: (T & OutletContent) | null },
	store: string
) {
	// The store is mango or outlet content not exists
	if (store === Channel.Shop || !main.outletContent) {
		return main
	}

	const { content, outletContent } = main
	const { contentOverwriteSelector: selector } = outletContent

	// Outlet content is used if content type has not overwrite content selector (e.g. categories list)
	if (selector === undefined) {
		return { ...main, content: main.outletContent }
	}

	// Shop content is used if Content type has overwrite selector but it not fullfilled
	if (selector === null) {
		return main
	}

	const result = assignContentSelector<T>(selector, content, outletContent)

	return { ...main, content: result }
}
